import { LitEntity, html } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

class BinsConfiguredCount extends LitEntity {
  static get styles() {
    return sharedStyles;
  }

  render() {
    return this.entity ?
      html`${this.entity.properties.configuredCount}` :
      html`<bn-icon name="fas fa-spinner fa-pulse"></bn-icon>`;
  }
}

window.customElements.define('bins-configured-count', BinsConfiguredCount);
